import http from '../plugins/http'
import { ADMIN_DASHBOARD, USER_IMPORT, USER_PROFILE } from '@/config/config_api_backend'
import stringInject from 'stringinject'

const apiGetAllDocumentAdmin = async (params) => {
    try {
        let response = await http.get(ADMIN_DASHBOARD.GET_DOCUMENT_ALL, {
            params: params,
        },)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiGetStatistic = async () => {
    let response = await http.get(ADMIN_DASHBOARD.GET_STATISTIC)
    return response.data
}

const apiGetAllTrivialSentence = async (params) => {
    let response = await http.get(ADMIN_DASHBOARD.GET_TRIVIAL_SENTENCE, {
        params: params,
    })
    return response.data
}

const apiGetAllTrivialCandidateSentence = async (params) => {
    let response = await http.get(ADMIN_DASHBOARD.GET_TRIVIAL_CANDIDATE_SENTENCE, {
        params: params,
    })
    return response.data
}

const apiDeleteTrivialSentence = async (id) => {
    let url = stringInject(ADMIN_DASHBOARD.DELETE_TRIVIAL_SENTENCE, {'id': id})
    let response = await http.delete(url)
    return response.data
}

const apiConfirmTrivialSentence = async (sentences) => {
    let url = stringInject(ADMIN_DASHBOARD.CONFIRM_TRIVIAL_CANDIDATE_SENTENCE)
    let response = await http.post(url, JSON.stringify(sentences),  {
        headers: {
            'Content-Type': 'application/json'
        }
    })
    return response.data
}

const apiAddTrivialSentence = async (sentences) => {
    let data = {}
    data.sentences = sentences
    let response = await http.put(ADMIN_DASHBOARD.PUT_TRIVIAL_SENTENCES, JSON.stringify(data), {
        headers: {
            'Content-Type': 'application/json'
        }
    })
    return response.data
}

const apiUploadBlacklistFile = async (file) => {
    try {
        const formData = new FormData()
        formData.append('file', file)

        let response = await http.post(ADMIN_DASHBOARD.UPLOAD_BLACKLIST, formData, { 'Content-Type': 'multipart/form-data' })
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiGetBlacklistFileAsArrayBuffer = async () => {
    try {
        let response = await http.get(ADMIN_DASHBOARD.GET_BLACKLIST,
          {
              responseType: 'arraybuffer'
          })
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}


export {
    apiGetAllDocumentAdmin,
    apiGetStatistic,
    apiGetAllTrivialSentence,
    apiAddTrivialSentence,
    apiDeleteTrivialSentence,
    apiGetAllTrivialCandidateSentence,
    apiConfirmTrivialSentence,
    apiUploadBlacklistFile,
    apiGetBlacklistFileAsArrayBuffer
}
